import * as React from 'react';
import { Helper } from '../../../../Helper';
import { IComposerImage } from '../../../../interfaces/IComposerImage';
import { Environment } from '../../../../services/Environment';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAIcon } from '../../../icon/Icon';
import * as styles from './Tiles.css';

export interface IProps {
  images: IComposerImage[];
  token: string;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  maxImages: number;
  editMode: boolean;
  bordeRadius?: number;
  openImageViewer: (index: number) => void;
}

export interface IState {
}

export class Tiles extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const images = [];
    this.props.images.forEach((image: IComposerImage, index) => {
      if (this.props.maxImages > index) {
        images.push(
          <div
            key={`image_${image.name}`}
            className={styles.IA_tilesImageWrapper}
          >
            <div className={styles.IA_tilesImageSpinner}>
              <IAIcon
                title="Spinner"
                size={20}
                color={"#999999"}
              />
            </div>
            <div
              className={styles.IA_tilesImage}
              style={{
                borderRadius: this.props.bordeRadius ?? 0,
                backgroundImage: `url("${Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, image.url, image.modified, "Full")}")`
              }}
              onClick={() => !this.props.editMode ? this.props.openImageViewer(index) : {}}
            />
          </div>
        );
      }
    });
    return (
      <div>
        <div
          className={styles.IA_tiles}
          id={"IA_tiles"}
        >
          {images}
        </div>
        {this.props.images.length - this.props.maxImages > 0 &&
          <div
            className={styles.IA_moreImages}
            onClick={() => this.props.openImageViewer(this.props.maxImages)}
          >
            <IAIcon
              title="ImageGallery"
              size={24}
              color={"#ffffff"}
              onClick={() => { }}
              style={{
                float: "left",
                cursor: "pointer",
                marginRight: 6,
                height: 20,
                marginTop: -2
              }} />
            {this.props.images.length - this.props.maxImages === 1 ? this.localizationService.strings.Composer_OneMoreImage : `${this.props.images.length - this.props.maxImages} ${this.localizationService.strings.Composer_MoreImages}`}
          </div>
        }
      </div>
    );
  }
}